import { lazy, Suspense, useEffect, useState } from "react";
import BlogDetailInfo from "./BlogDetailInfo";
const BlogDetailCards = lazy(() => import("./BlogDetailCards"));
const CaseNewDetailForm = lazy(() => import("../caseNew/details/CaseNewDetailForm"));


export default function BlogDetails() {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <BlogDetailInfo />
      <Suspense fallback={null}>
        {isScroll &&
          (
            <>
              <BlogDetailCards />
              <CaseNewDetailForm />
            </>
          )}
      </Suspense>
    </>
  );
}
